import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { GraphQLResponse, Signer } from '@app/models';

/**
 * Helper service for common functionalities
 * Should only contain simple, non dependent logic, so that it can be used all across the application, including inside app/core, interceptors, etc...
 */
@Injectable({ providedIn: 'root' })
export class HelperService {
  constructor() {}

  storagePath(path: string) {
    if (/^(https?):/i.test(path)) {
      return path;
    }
    path = path.replace(/^\//, '');

    if (/\/v2/i.test(environment.serverUrl)) {
      return `${environment.serverUrl.replace(/\/v2/, '/storage')}/${path}`;
    }

    return `${environment.serverUrl}/storage/${path}`;
  }

  panelPath(path: string) {
    return `${environment.panelUrl.replace(/\/$/, '')}/${(path || '').replace(/^\//, '')}`;
  }

  signerLink(link: Signer['link']) {
    if (link) {
      return !this.isAutentiqueDomain() || environment.production ? link.short_link : this.panelPath(`/assinar/${link.id}`);
    }
  }

  currencyForCountry(country: string) {
    return country === 'BR' ? 'BRL' : 'USD';
  }

  currencyCodeFor(currency: string, withTrailingSpace = false) {
    const currencyCode = currency === 'BRL' ? 'R$' : '$';
    return withTrailingSpace ? currencyCode + ' ' : currencyCode;
  }

  getDecimalMarker(currency: string) {
    return currency === 'BRL' ? ',' : '.';
  }

  getThousandSeparator(currency: string) {
    return currency === 'BRL' ? '.' : ',';
  }

  isDocumentPage() {
    return /^\/assinar\/|\/s\/|(^\/(documentos|d)\/[A-Za-z0-9]{30})/.test(location.pathname) || /^valida\.ae/.test(location.host);
  }

  isAutentiqueDomain(host?: string) {
    const targetHost = host || location.host;
    return !targetHost || new RegExp(environment.validHostsRegExp, 'i').test(targetHost);
  }

  mockMessageValidationError(message: string): GraphQLResponse {
    return { data: null, status: 422, errors: [{ message }] };
  }

  mockFormValidationError(validation: { [attribute: string]: string[] }): GraphQLResponse {
    return { data: null, status: 422, errors: [{ message: 'validation', validation }] };
  }

  isTokenInvalidError(errorMessage: string): boolean {
    return !!errorMessage && ['token_invalid', 'token_expired'].includes(errorMessage);
  }

  cleanAttqDocumentMargins(content: string): string {
    return content.replace(/class="attq-document"\s+style="margin:\s*0\s+([\d.]+)cm\s+0\s+([\d.]+)cm;"/g, 'class="attq-document"');
  }

  parseQueryString(queryString: string): Record<string, string> {
    const params: Record<string, string> = {};
    if (!queryString) return params;
    new URLSearchParams(queryString).forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }

  isInsideIframe(): boolean {
    return window.top !== window.self;
  }
}
